import React, { useState, useEffect } from "react";

// Minimal campaign footer: logo + a single unsubscribe link, no marketing-preferences link,
// no social icons. Based on the cleaned-up footer from the BBD Cardiff campaign email.
const FooterMin = (props) => {

   useEffect(() => {
      props.updateComponentHTML(props.id,
         `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-2" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0" width="100%">
            <tbody>
                <tr>
                    <td>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#212859;color:#000;border-radius:0;width:600px" width="600">
                            <tbody>
                                <tr>
                                    <td class="column column-1 mobile_shorten" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0" width="13.5%">
                                        <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0" width="100%">
                                            <tr>
                                                <td class="pad" style="width:100%;padding-right:0;padding-left:0; text-align: left">
                                                    <div align="left" class="alignment" style="line-height:10px">
                                                        <img class="mobile_hide" src="https://awsuk01.fivecrm.com/603317/user_files/uploads/999/images/emailfooterfabe.jpg" style="display:block;height:auto;border:0;width:82px;max-width:100%" width="82"/>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="column column-3" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0" width="15%">
                                        <table border="0" cellpadding="0" cellspacing="0" class="heading_block block-2" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0" width="100%">
                                            <tr>
                                                <td class="pad" style="width:100%;text-align:center;padding-top:20px;padding-bottom:5px">
                                                    <h3 style="margin:0;color:#fff;font-size:16px;font-family:Myriad Pro, Arial,Helvetica Neue,Helvetica,sans-serif;line-height:120%;text-align:center;direction:ltr;font-weight:400;letter-spacing:normal;margin-top:0;margin-bottom:0">
                                                        <span class="tinyMce-placeholder"><a href="*unsubscribe" style="text-decoration: none; font-size:12px; line-height:10px"><span style="color:#FFFFFF">Unsubscribe</span></a></span>
                                                    </h3>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="column column-4" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0" width="20%">&nbsp;</td>
                                    <td class="column column-7" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0" width="5%">&nbsp;</td>
                                    <td class="column column-5" style="padding-top:3px; mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0" width="16.666666666666668%">
                                        <table border="0" cellpadding="0" cellspacing="0" class="empty_block block-2" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0" width="100%">
                                            <tr>
                                            <td class="pad" style="width:100%;padding-right:0;padding-left:0; padding-top:16px; text-align: center">
                                                <div align="center" class="alignment" style="line-height:10px">
                                                    <img src="https://awsuk01.fivecrm.com/603317/user_files/uploads/999/images/100x98%20white.png" style="display:block;height:auto;border:0;width:86px;max-width:100%" width="86"/>
                                                </div>
                                        </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
         `)
   }, [])

   return (
      <>

      </>
   )
}

export default FooterMin;
